"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// styles
require("./styles/orders.scss");
var controllers_1 = require("./controllers");
var services_1 = require("./services");
var routes_1 = __importDefault(require("./config/routes"));
/**
 * @ngdoc module
 * @module rinca.apps.discount
 * @name rinca.apps.discount
 * @packageName rinca.apps
 * @description A module that includes the discount component.
 */
angular.module('rinca.apps.orders', ['ui.router'])
    .controller('OrderListController', controllers_1.OrderListController)
    .service('_orders', services_1.OrderService)
    .config(routes_1.default);



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/order-list/index.js
// module id = 411
// module chunks = 0